<template>
  <div class="mb-3 mt-3">
    <b-container>
      <p v-if="showError === 'not found'">{{ $t('queen.form.not_found') }}</p>
      <div class="d-flex justify-content-around"><b-spinner v-if="!loaded && !showError"></b-spinner></div>
      <template v-if="loaded">
        <h1 class="text-primary font-weight-bold text-center mb-5">{{ data.title }} <b-link class="text-body icon-pen text-decoration-none" :title="$t('queen_edit.title')" :to="'/queen/edit/' + id + '/' + colony + '/' + apiary"></b-link></h1>
      </template>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Queen',
  props: ['id', 'apiary', 'colony'],
  data () {
    return {
      showError: false,
      loaded: false,
      data: {
        title: null
      }
    }
  },
  async mounted () {
    if (this.id) {
      try {
        this.data = await this.$api.queens.getOne(this.id)
        if (this.data) {
          this.loaded = true
        } else {
          this.showError = 'not found'
        }
      } catch (e) {
        this.showError = 'not found'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  h1 {
    .icon-pen {
      font-size: 1.5rem;
    }
  }
</style>
